import { all, call, cancelled, put, takeLatest } from "redux-saga/effects";
import NotificationService from "../../services/NotificationService";
import {
  GetContentFailure,
  GetContentSuccess,
  GetFailure,
  GetSuccess,
  listFail,
  listSuccess,
  updateNotificationContentFailure,
  updateNotificationContentSuccess,
  updateStatusFail,
  updateStatusSuccess,
  updateDisabledStatusSuccess,
  updateNotiBasicInfoSuccess,
  CreateNotificationContentFailure,
  CreateNotificationContentSuccess,
  GetOthersCategorySuccess,
  GetOthersCategoryFailure,
  GetNotificationLogsSuccess,
  GetNotificationLogsFailure,
  notificationExportRequest,
  notificationExportSuccess,
  notificationExportFail,
  updateNotificationRecipantSuccsess
} from "../slices/notificationSlice";

function* list(data) {
  try {
    const ajax = yield call(NotificationService.GetList, data.payload);
      if (ajax.status === 200) {
      yield put(listSuccess(ajax.data));
    } else {
      yield put(
        listFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      listFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* GetNotificationById(data)
{
  try {
    const ajax = yield call(
      NotificationService.GetNotificationById,
      data.payload
    );
    if (ajax.status === 200) {
      console.log(ajax.data)
      yield put(GetSuccess(ajax.data));
    } else {
      yield put(
        GetFailure({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      GetFailure({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* updateStatus(data) {
  try {
    const ajax = yield call(
      NotificationService.updateNotificationStatus,
      data.payload
    );
    if (ajax.status === 200) {
      if (data.payload.status === true)
      {
        yield put(updateStatusSuccess(ajax.data));
      }else{
        yield put(updateDisabledStatusSuccess(ajax.data));
      }
    } else {
      yield put(
        updateStatusFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      updateStatusFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* updateCustomeNotiBasicInfo(data) {

   try {
    const ajax = yield call(
      NotificationService.UpdateCustomerNotiBasicInfo,
      data.payload
    );
    if (ajax.status === 200) {
      yield put(updateNotiBasicInfoSuccess(ajax.data));
    } else {
      yield put(
        updateNotificationContentFailure({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      updateNotificationContentFailure({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* updateCustomNotiRecipant(data){
   try {
    console.log(data.payload.data)
    const ajax = yield call(
      NotificationService.UpdateCustomerNotiRecipnat,
      data.payload
    );
    if (ajax.status === 200) {
      yield put(updateNotificationRecipantSuccsess(ajax.data));
    } else {
      yield put(
        updateNotificationContentFailure({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      updateNotificationContentFailure({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* updateNotification(data) {
  try {
    console.log(data.payload.data)
    const ajax = yield call(
      NotificationService.UpdateNofiication,
      data.payload
    );
    if (ajax.status === 200) {
      yield put(updateNotificationContentSuccess(ajax.data));
    } else {
      yield put(
        updateNotificationContentFailure({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      updateNotificationContentFailure({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* GetNotificationContentByKey(data)
{
  try {
    const ajax = yield call(
      NotificationService.GetNotificationContentByKey,
      data.payload
    );
    if (ajax.status === 200) {
      console.log(ajax.data)
      yield put(GetContentSuccess(ajax.data));
    } else {
      yield put(
        GetContentFailure({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      GetContentFailure({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data|| {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* GetOthersCategory()
{
  try {
    console.log("fetch category")
    const ajax = yield call(
      NotificationService.GetOthersCategory
    );
    if (ajax.status === 200) {
      console.log(ajax.data)
      yield put(GetOthersCategorySuccess(ajax.data));
    } else {
      yield put(
        GetOthersCategoryFailure({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      GetOthersCategoryFailure({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* GetNotificationLogs(action)
{
  try {
    console.log("fetch noti logs")
    const query = action.payload || {};
    console.log("Fetching notification logs with query:", query);

    // Pass query params to the service
    const ajax = yield call(NotificationService.GetNotificationLogs, query);
    // const ajax = yield call(
    //   NotificationService.GetNotificationLogs
    // );
    if (ajax.status === 200) {
      console.log(ajax.data)
      yield put(GetNotificationLogsSuccess(ajax.data));
    } else {
      yield put(
        GetNotificationLogsFailure({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      GetNotificationLogsFailure({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}
function* GetNotificationClone(data)
{
  try {
    const ajax = yield call(
      NotificationService.GetNotificationClone,
      data.payload
    );
    if (ajax.status === 200) {
      console.log("Clone notification",ajax.data)
      yield put(GetSuccess(ajax.data));
    } else {
      yield put(
        GetFailure({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      GetFailure({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* createNotification(data) {
  try {
    console.log(data.payload.data)
    const ajax = yield call(
      NotificationService.CreateNotification,
      data.payload
    );
    if (ajax.status === 200) {
      console.log(ajax.data)
      yield put(CreateNotificationContentSuccess(ajax.data));
    } else {
      yield put(
        CreateNotificationContentFailure({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      CreateNotificationContentFailure({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* NotificationAlreadyExist(action) {
  try {
    const ajax = yield call(
      NotificationService.NotificationAlreadyExist,
      action.payload
    );
    if (ajax.status === 200) {
      // Store API response in slice as `notiStatus`
      yield put(GetSuccess({ notiStatus: ajax.data })); // ajax.data = { response: true/false, ... }
    } else {
      yield put(GetFailure({ status: ajax.status, errors: ajax.data }));
    }
  } catch (error) {
    yield put(
      GetFailure({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  }
}

// function* exportNotifications(data) {
//   try {
//     const { fileType = "excel" } = data.payload;

//     let extension = "xlsx";
//     if (fileType === "csv") extension = "csv";
//     else if (fileType === "pdf") extension = "pdf";

//     const ajax = yield call(NotificationService.export, data.payload);

//     if (ajax.status === 200) {
//       const url = window.URL.createObjectURL(new Blob([ajax.data]), {
//         type: ajax.headers["content-type"],
//       });
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", `notifications.${extension}`);
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       yield put(notificationExportSuccess());
//     } else {
//       yield put(
//         notificationExportFail({
//           status: ajax.status,
//           errors: ajax.data,
//         })
//       );
//     }
//   } catch (error) {
//     yield put(
//       notificationExportFail({
//         status: 400,
//         response: "SOMETHING_ELSE_WRONG",
//         ...(error?.response?.data || {}),
//       })
//     );
//   } finally {
//     if (yield cancelled()) {
//       yield put({ type: "cancel" });
//     }
//   }
// }

function* exportNotifications(action) {
  try {
      console.log("⚡ exportNotifications saga triggered with payload:", action.payload);

    const { fileType, query } = action.payload;
    const ajax = yield call(NotificationService.export, { fileType, query });
      console.log(ajax,"ajax--->>>")
      const text = ajax.data.text;
console.log("📄 File raw content (if readable):", text);
    if (ajax.status === 200) {
      // ✅ create downloadable blob
      const blob = new Blob([ajax.data], { type: ajax.headers["content-type"] });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      // Pick file extension dynamically
      let ext = "xlsx";
      if (fileType === "csv") ext = "csv";
      if (fileType === "pdf") ext = "pdf";

      link.setAttribute("download", `notifications.${ext}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      yield put(notificationExportSuccess());
    } else {
      yield put(notificationExportFail({ status: ajax.status }));
    }
  } catch (error) {
    yield put(notificationExportFail({ status: error?.response?.status || 400 }));
  }
}
export default function* notificationSaga() {
  yield all([
    takeLatest("notifications/listRequest", list),
    takeLatest("notifications/updateStatusRequest", updateStatus),
    takeLatest("notifications/GetNotificationRequest", GetNotificationById),
    takeLatest("notifications/updateNotificationContentRequest", updateNotification),
    takeLatest("notifications/GetContentRequest", GetNotificationContentByKey),
    takeLatest("notifications/GetOthersCategoryRequest",GetOthersCategory),
    takeLatest("notifications/CreateNotificationContentRequest",createNotification),
    takeLatest("notifications/GetNotificationClone",GetNotificationClone),
    takeLatest("notifications/NotificationAlreadyExist",NotificationAlreadyExist),
    takeLatest("notifications/updateNotiBasicInfo",updateCustomeNotiBasicInfo),
    takeLatest("notifications/GetNotificationLogs",GetNotificationLogs),
    takeLatest("notifications/notificationExportRequest", exportNotifications),
    takeLatest("notifications/updateCustomNotiRecipant", updateCustomNotiRecipant),
  ]);
}